// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1FOVA","error":"Textarea_error__39lyG","readonly":"Textarea_readonly__3H-tl","disabled":"Textarea_disabled__3cdFU"};